// Batch yield overlay helper.
// Given the raw `ingredientsById` map and the active batches map (from
// `GET /api/batch-yield/active`), returns a NEW ingredients map where
// each ingredient with an active batch has its `yield_percent` swapped
// for the batch's `actual_yield_percent`. Downstream cost math is
// automatically corrected because `computeLineCost` derives food cost
// from `purchase_price / (purchase_qty * yield_factor)`.
//
// We never mutate the original map: callers still need it for baseline
// comparisons and for editing the ingredient row itself.
export function applyBatchOverrides(ingredientsById, activeBatchesById) {
  if (!ingredientsById || !activeBatchesById) return ingredientsById || {};
  const overridden = {};
  for (const [id, ing] of Object.entries(ingredientsById)) {
    const batch = activeBatchesById[id];
    if (batch && Number.isFinite(batch.actual_yield_percent) && batch.actual_yield_percent > 0) {
      overridden[id] = {
        ...ing,
        yield_percent: batch.actual_yield_percent,
        _baseline_yield_percent: ing.yield_percent,
        _batch_id: batch.id,
        _batch_alert: !!batch.is_yield_alert,
      };
    } else {
      overridden[id] = ing;
    }
  }
  return overridden;
}
